// frontend/src/features/livestock/photoInboxRecents.ts
// The organisms photos were last assigned to, per tank, newest first, for the
// assign view's Recent chips (plan 4.4). Kept in localStorage; without it
// (private mode, blocked site data) the list lasts as long as the page.

export const RECENT_LIMIT = 5;

const KEY_PREFIX = 'rdh-photo-inbox-recent:';

const memory = new Map<string, number[]>();

function storageKey(tankId: string): string {
  return `${KEY_PREFIX}${tankId}`;
}

function clean(value: unknown): number[] {
  if (!Array.isArray(value)) return [];
  const ids: number[] = [];
  for (const id of value) {
    if (Number.isInteger(id) && id > 0 && !ids.includes(id)) ids.push(id);
  }
  return ids.slice(0, RECENT_LIMIT);
}

export function readRecents(tankId: string): number[] {
  let stored: string | null;
  try {
    stored = localStorage.getItem(storageKey(tankId));
  } catch {
    return memory.get(tankId) ?? [];
  }
  try {
    return stored === null ? [] : clean(JSON.parse(stored));
  } catch {
    return [];
  }
}

export function writeRecents(tankId: string, ids: number[]): void {
  const cleaned = clean(ids);
  memory.set(tankId, cleaned);
  try {
    localStorage.setItem(storageKey(tankId), JSON.stringify(cleaned));
  } catch {
    // storage full or blocked: the in-memory list still serves this page
  }
}

/** Puts the organism first and returns the new list. */
export function pushRecent(tankId: string, livestockId: number): number[] {
  const next = [livestockId, ...readRecents(tankId).filter((id) => id !== livestockId)].slice(
    0,
    RECENT_LIMIT
  );
  writeRecents(tankId, next);
  return next;
}

/** Forgets every tank's list, on sign-out and when another user signs in (shared devices). */
export function clearRecents(): void {
  memory.clear();
  try {
    const keys: string[] = [];
    for (let index = 0; index < localStorage.length; index++) {
      const key = localStorage.key(index);
      if (key?.startsWith(KEY_PREFIX)) keys.push(key);
    }
    for (const key of keys) localStorage.removeItem(key);
  } catch {
    // storage blocked: nothing was stored
  }
}
